export const reviewsData = [
  {
    id: 1,
    author: "Erika Mcmillian",
    date: "10 months ago",
    rating: 5,
    text: "I finally made a decision to change my career and royal dental assistant academy help me do that the instructors truly care about the people that step through their doors thank you to the ladies of Royal dental assistant academy class of 25' WE DID IT!!!!!!!"
  },
  {
    id: 2,
    author: "Yeimi Pastor",
    date: "2 months ago",
    rating: 5,
    text: "I highly recommend this academy, the course is super comple. Great instructor and this was a wonderful experience thank you Royal Dental Academy 🤍 10/10"
  },
  {
    id: 3,
    author: "Leland Cerna",
    date: "a year ago",
    rating: 5,
    text: "This program was a decision I will not regret. The instructors are super friendly and patient. While doing this program I had students in my class that only spoke Spanish. The instructors were very patient with them and found different ways..."
  },
  {
    id: 4,
    author: "Camilla D",
    date: "2 years ago",
    rating: 5,
    text: "I can't even put into words how grateful I am for my time at Royal Dental Assistant academy . Not only did I gain invaluable skills and knowledge, but the professors and staff truly cared about my success. The sense of community among the..."
  },
  {
    id: 5,
    author: "maria e",
    date: "a year ago",
    rating: 5,
    text: "Loved the atmosphere & the teachers. Totally recommend! Had fun while learning & started working right after graduation. Loved that they taught us both in Spanish & English."
  },
  {
    id: 6,
    author: "Daisy",
    date: "a year ago",
    rating: 5,
    text: "Best dental assistant academy!! Teachers and students were so welcoming and friendly. It was such a great environment, they truly make sure you understand everything and will go above and beyond to help you succeed!! Thank you to everyone !!"
  },
  {
    id: 7,
    author: "Tyesha Durham",
    date: "2 years ago",
    rating: 5,
    text: "My experience with Royal Dental was Phenomenal and life changing. The instructors, Lupe and Modesta are great and very patient and helpful with anything you need during and after you graduate. This program is well worth it and I highly recommend!!"
  },
  {
    id: 8,
    author: "Lanny Cruz",
    date: "a year ago",
    rating: 5,
    text: "You will learn a lot, my favorite experience was (hands on) clinical practice. Thank you Royal Dental Assistant academy. ☺️♥️🙏🏻"
  },
  {
    id: 9,
    author: "Valeria Navas",
    date: "a year ago",
    rating: 5,
    text: "“I attended Royal Dentist Academy last year and earned my dental assisting certificate. The program was well-structured, providing a great mix of hands-on experience and comprehensive theoretical knowledge. The instructors were highly..."
  },
  {
    id: 10,
    author: "karen manon",
    date: "2 years ago",
    rating: 5,
    text: "I had an amazing experience with Royal dental academy they were amazing and really have a passion to teach others. Would 100% recommend to anyone who is interested in the dental field 🦷 ❤️"
  },
  {
    id: 11,
    author: "modesta vera",
    date: "2 months ago",
    rating: 5,
    text: "Best Dental Assistant School"
  },
  {
    id: 12,
    author: "Ahkeia Mayfield",
    date: "a year ago",
    rating: 5,
    text: "Amazing academy I learned so much , great instructors and this was a wonderful experience thank you"
  },
  {
    id: 13,
    author: "Luis Fernando Alban giler",
    date: "a year ago",
    rating: 5,
    text: "Good teachings, good teachers, always attentive to any questions and ask the best"
  },
  {
    id: 14,
    author: "Abdullah Mahmud",
    date: "a day ago",
    rating: 5,
    text: "I highly recommend this program for anyone looking into entering the dental assisting career. You won't be disappointed!"
  },
  {
    id: 15,
    author: "Dayana Parraga",
    date: "a year ago",
    rating: 5,
    text: "I had a very positive experience at Royal Dental Assistant Academy. The teachers are highly qualified and always willing to help, which makes for an excellent learning environment. Furthermore, the facilities are modern and have everything..."
  },
  {
    id: 16,
    author: "Yogen Alan Navas Collantes",
    date: "a year ago",
    rating: 5,
    text: "Attending this dental assistant school has been an amazing experience! The instructors are knowledgeable, supportive, and truly care about students' success. The hands-on training is excellent, and the curriculum is well-structured, making..."
  },
  {
    id: 17,
    author: "Bibiana Hernández",
    date: "a year ago",
    rating: 5,
    text: "I highly recommend this academy; the course is super comprehensive."
  }
];
